var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69727 16.9638L8.83727 16.1038C7.65727 14.9238 7.66727 13.0038 8.85727 11.8438L9.69727 11.0238C9.30727 10.9838 9.01727 10.9638 8.69727 10.9638C6.02727 10.9638 0.697266 12.3038 0.697266 14.9638V16.9638H9.69727ZM8.69727 8.96375C10.9073 8.96375 12.6973 7.17375 12.6973 4.96375C12.6973 2.75375 10.9073 0.963753 8.69727 0.963753C6.48727 0.963753 4.69727 2.75375 4.69727 4.96375C4.69727 7.17375 6.48727 8.96375 8.69727 8.96375Z",
    fill: "#00205A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8773 16.7438C13.4873 17.1338 12.8473 17.1338 12.4573 16.7438L10.3873 14.6538C10.0073 14.2638 10.0073 13.6438 10.3873 13.2638L10.3973 13.2538C10.7873 12.8638 11.4173 12.8638 11.7973 13.2538L13.1673 14.6238L17.5973 10.1638C17.9873 9.77375 18.6173 9.77375 19.0073 10.1638L19.0173 10.1738C19.3973 10.5638 19.3973 11.1838 19.0173 11.5638L13.8773 16.7438Z",
    fill: "#00205A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCheck);
export default __webpack_public_path__ + "static/media/person_check.87eed33d3e136b3a9231cbe7b41a42ee.svg";
export { ForwardRef as ReactComponent };